<template>
  <div class="data-weather">
    <el-row :gutter="gutter">
      <el-col :md="span"
              :xs="24"
              :sm="12"
              v-for="(item, index) in data"
              :key="index">
        <div class="data-weather__item"
             :style="getItemStyle(item)"
             @click="item.click && item.click(item)">
          <div class="data-weather__header">
            <span class="data-weather__city">{{ item.city }}</span>
            <span class="data-weather__date">{{ item.date }}</span>
          </div>
          <div class="data-weather__body">
            <div class="data-weather__icon">
              <i :class="getWeatherIcon(item.weather)" :style="{fontSize: '48px'}"></i>
            </div>
            <div class="data-weather__temp">
              <span class="data-weather__temp-value">{{ item.temp }}</span>
              <span class="data-weather__temp-unit">°C</span>
            </div>
          </div>
          <div class="data-weather__footer">
            <span class="data-weather__desc">{{ item.weather }}</span>
            <span class="data-weather__wind" v-if="item.wind">{{ item.wind }}</span>
          </div>
          <div class="data-weather__range" v-if="item.tempLow !== undefined">
            {{ item.tempLow }}° ~ {{ item.tempHigh }}°
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import create from "core/create";
export default create({
  name: "data-weather",
  data() {
    return {};
  },
  props: {
    option: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    span() {
      return this.option.span || 6;
    },
    gutter() {
      return this.option.gutter || 20;
    },
    data() {
      return this.option.data || [];
    }
  },
  methods: {
    getItemStyle(item) {
      const gradients = {
        '晴': 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        '多云': 'linear-gradient(135deg, #89f7fe 0%, #66a6ff 100%)',
        '阴': 'linear-gradient(135deg, #bdc3c7 0%, #2c3e50 100%)',
        '雨': 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
        '雪': 'linear-gradient(135deg, #e0eafc 0%, #cfdef3 100%)'
      };
      return {
        background: item.background || gradients[item.weather] || gradients['晴']
      };
    },
    getWeatherIcon(weather) {
      const icons = {
        '晴': 'el-icon-sunny',
        '多云': 'el-icon-partly-cloudy',
        '阴': 'el-icon-cloudy',
        '雨': 'el-icon-heavy-rain',
        '雪': 'el-icon-ice-cream'
      };
      return icons[weather] || 'el-icon-sunny';
    }
  }
});
</script>
